// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
// Auth
import { AuthGuard } from './core/auth';
import { NgxPermissionsModule } from 'ngx-permissions';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'profile',
        loadChildren: () =>
          import('./views/pages/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: 'my-archive',
        loadChildren: () =>
          import('./views/pages/archive/archive.module').then(
            (m) => m.ArchiveModule
          ),
      },
      {
        path: 'live-view',
        loadChildren: () =>
          import('./views/pages/live-view/live-view.module').then(
            (m) => m.LiveViewModule
          ),
      },
      {
        path: 'amplitude-overview',
        loadChildren: () =>
          import('./views/pages/genius-chart/genius-chart.module').then(
            (m) => m.GeniusChartModule
          ),
      },
      {
        path: 'raw-chart',
        loadChildren: () =>
          import('./views/pages/raw-chart/raw-chart.module').then(
            (m) => m.RawChartModule
          ),
      },
      {
        path: 'ratio-chart',
        loadChildren: () =>
          import('./views/pages/ratio-chart/ratio-chart.module').then(
            (m) => m.RatioChartModule
          ),
      },
      {
        path: 'test',
        loadChildren: () =>
          import('./views/pages/test-screen/test-screen.module').then(
            (m) => m.TestScreenModule
          ),
      },
      {
        path: 'test-configuration',
        loadChildren: () =>
          import('./views/pages/test-configuration/test-configuration.module').then(
            (m) => m.TestConfigurationModule
          ),
      },
      {
        path: 'training-configuration',
        loadChildren: () =>
          import('./views/pages/training-configuration/training-configuration.module').then(
            (m) => m.TrainingConfigurationModule
          ),
      },
      {
        path: 'training-screen',
        loadChildren: () =>
          import('./views/pages/training-screen/training-screen.module').then(
            (m) => m.TrainingScreenModule
          ),
      },
      {
        path: 'remote-training',
        loadChildren: () =>
          import('./views/pages/custom-training-screen/custom-training-screen/custom-training-screen.module').then(
            (m) => m.CustomTrainingScreenModule
          ),
      },
      {
        path: 'statistic',
        loadChildren: () =>
          import('./views/pages/statistics/statistics.module').then(
            (m) => m.StatisticsModule
          ),
      },
      {
        path: 'recordings',
        loadChildren: () =>
          import('./views/pages/recordings/recordings.module').then(
            (m) => m.RecordingsModule
          ),
      },
      // {
      //   path: 'pulse-bluetooth',
      //   loadChildren: () =>
      //     import('./views/pages/pulse-bluetooth/pulse-bluetooth.module').then(
      //       (m) => m.PulseBluetoothModule
      //     ),
      // },
      {
        path: 'credits',
        loadChildren: () =>
          import('./views/pages/credits/credits.module').then(
            (m) => m.CreditsModule
          ),
      },
      {
        path: 'supervisors-tree',
        loadChildren: () =>
          import('./views/pages/supervisors-tree/supervisors-tree.module').then(
            (m) => m.SupervisorsTreeModule
          ),
      },
      {
        path: 'supervisors-activity',
        loadChildren: () =>
          import('./views/pages/supervisor-activity/supervisor-activity.module').then(
            (m) => m.SupervisorActivityModule
          ),
      },
      {
        path: 'device-overview',
        loadChildren: () =>
          import('./views/pages/device-overview/device-overview.module').then(
            (m) => m.DeviceOverviewModule
          ),
      },
      {
        path: 'analysis',
        loadChildren: () =>
          import('./views/pages/analysis/analysis.module').then(
            (m) => m.AnalysisModule
          ),
      },
      // {
      //   path: 'mail',
      //   loadChildren: () => import('./views/pages/apps/mail/mail.module').then(m => m.MailModule),
      // },
      // {
      //   path: 'ecommerce',
      //   loadChildren: () => import('./views/pages/apps/e-commerce/e-commerce.module').then(m => m.ECommerceModule),
      // },
      // {
      //   path: 'ngbootstrap',
      //   loadChildren: () => import('./views/pages/ngbootstrap/ngbootstrap.module').then(m => m.NgbootstrapModule),
      // },
      // {
      //   path: 'material',
      //   loadChildren: () => import('./views/pages/material/material.module').then(m => m.MaterialModule),
      // },
      // {
      //   path: 'wizard',
      //   loadChildren: () => import('./views/pages/wizard/wizard.module').then(m => m.WizardModule),
      // },
      // {
      //   path: 'builder',
      //   loadChildren: () => import('./views/theme/content/builder/builder.module').then(m => m.BuilderModule),
      // },
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes), NgxPermissionsModule.forChild()],
  exports: [RouterModule],
})
export class AppRoutingModule {}
